<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

const encryptedText = this.CryptoJS.AES.encrypt("Hi There!",  'secret key 123').toString()
const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto)=>{
        return this.CryptoJS.AES.encrypt(texto,  'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto)=>{
        return this.CryptoJS.AES.decrypt(texto,'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf,num_cand)=>{

        let candidato = {CPF:cpf,NUMEROINSC:num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-','')*7919;
        codigo_meio=codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0,5))*parseInt(candidato.NUMEROINSC.replace('-',''))*13 + '_'
        + String.fromCharCode(65 + parseInt(codigo_meio[3]))
        + String.fromCharCode(parseInt(codigo_meio[1]%2===0? 97 : 67)+ parseInt(codigo_meio[1]))
        + String.fromCharCode(parseInt(codigo_meio[4]%2===0? 97 : 67)+ parseInt(codigo_meio[5]))
        + String.fromCharCode(parseInt(codigo_meio[3]%2===0? 97 : 67)+ parseInt(codigo_meio[2]))
        + String.fromCharCode(parseInt(codigo_meio[7]%2===0? 97 : 67)+ parseInt(codigo_meio[7]))
        + '-'
        + String.fromCharCode(parseInt(codigo_meio[0]%2===0? 97 : 67)+ parseInt(codigo_meio[11]))
        + String.fromCharCode(parseInt(codigo_meio[1]%2===0? 97 : 67)+ parseInt(codigo_meio[9]))
        + String.fromCharCode(parseInt(codigo_meio[5]%2===0? 97 : 67)+ parseInt(codigo_meio[4]))
        + String.fromCharCode(parseInt(codigo_meio[8]%2===0? 97 : 67)+ parseInt(codigo_meio[5]))
        + String.fromCharCode(parseInt(codigo_meio[3]%2===0? 97 : 67)+ parseInt(codigo_meio[8]))
        + '_'
        + String.fromCharCode(parseInt(codigo_meio[2]%2===0? 97 : 67)+ parseInt(codigo_meio[3]))
        + String.fromCharCode(parseInt(codigo_meio[8]%2===0? 97 : 67)+ parseInt(codigo_meio[4]))
        + String.fromCharCode(parseInt(codigo_meio[3]%2===0? 97 : 67)+ parseInt(codigo_meio[6]))
        + String.fromCharCode(parseInt(codigo_meio[6]%2===0? 97 : 67)+ parseInt(codigo_meio[2]))
        + String.fromCharCode(parseInt(codigo_meio[3]%2===0? 97 : 67)+ parseInt(codigo_meio[11]))
        + String.fromCharCode(parseInt(codigo_meio[8]%2===0? 97 : 67)+ parseInt(codigo_meio[9]))

        return codigo_arquivo+'.pdf';
      }


      let cands = [{"num_cand":"U2FsdGVkX1/sglLCXYigiNP3oPNW2z8IKhoAd3KSy3Y=","cpf":"U2FsdGVkX18DfMJX11oCGUoPqt6SyqeGnNJPdQVjTrY="},
{"num_cand":"U2FsdGVkX19xWQHroGmwljgbA3MBlasmaWkJ9a76Cbc=","cpf":"U2FsdGVkX19BgYgtiTFTIign1PnmayvxfNyWEiw4nqc="},
{"num_cand":"U2FsdGVkX1/Yh/wqAOYPFJ222pfxkGeWtKggcX0/LA0=","cpf":"U2FsdGVkX19pwMmJ/g+N5AUhWSg0kjZO4JuTGtOh83M="},
{"num_cand":"U2FsdGVkX186gE5BGND34EBhCl3vM0yTJ9JrWmEsC7E=","cpf":"U2FsdGVkX1+AauSXQh8beZUWDDF71RArow3wi7YOy9o="},
{"num_cand":"U2FsdGVkX19klCbevT67Ckw/eLUrF1RYmrPYH2jOvpQ=","cpf":"U2FsdGVkX1+xnZlocQa3vilBZk+un8tiVLIdDsMcs0M="},
{"num_cand":"U2FsdGVkX18Jkrg1UBeUWIN34Z8OAwwxkEjdKxWUZWY=","cpf":"U2FsdGVkX19F00tWwENr62dA6QYIY0brqkNmprEvv4U="},
{"num_cand":"U2FsdGVkX1+1IlvOYGpLeDDGeDK4VAkzPh1pShd8uPA=","cpf":"U2FsdGVkX1+QXiXXtxdV6y60EEmWsfaQlkmKQOfnnCw="},
{"num_cand":"U2FsdGVkX19AIn9I3S+XMbyfquD+5ESlMKAN0Pg680g=","cpf":"U2FsdGVkX1/EG+xcj0nDZajd6KK4azpIV9H4OKWpnV4="},
{"num_cand":"U2FsdGVkX1/puGgEodwBIPQPagaJBXv4V66RFridlaA=","cpf":"U2FsdGVkX1/8oFzDnUJ336/wGUnDj2mVrvZxa4DS5o0="},
{"num_cand":"U2FsdGVkX19DTYVUxD8wm1NxxaiAT6+wzlKH0xnh+CA=","cpf":"U2FsdGVkX18nCAzr0B9KpjbKaqVhJyY0Li+aLL4r67E="},
{"num_cand":"U2FsdGVkX18krx6YS/QVSilSunPKdjjQrY6GPODd9Sk=","cpf":"U2FsdGVkX18ZLFUS+wDAWULwGoMHuce1wfhUdTFspU0="},
{"num_cand":"U2FsdGVkX1/WVx8kysWolawTGwvOmzxsvmTS2ZH3FZk=","cpf":"U2FsdGVkX1+5hPkssqmP4mEO/Fva5WbDh31h9Cn0LwQ="},
{"num_cand":"U2FsdGVkX19chirO5TtXixFhAC8ElqfxYLzplI8SyqE=","cpf":"U2FsdGVkX18FvUn5RE2uFfHv4MDXPkELIRxg3PvjVCQ="},
{"num_cand":"U2FsdGVkX18laFUy6Jc4D88QB2h1FXQp6jRT5n4wlqk=","cpf":"U2FsdGVkX19YRBqnNj9bu63p9IzOKis93dzMRCL/Ufs="},
{"num_cand":"U2FsdGVkX18x4LcUlBnw+EpXcsRm6fUEjstDKr+YJRs=","cpf":"U2FsdGVkX198eBc9kV6AtZOSFvzOfseHqeMTH4G/a4s="},
{"num_cand":"U2FsdGVkX192j0xbHYGwdgANJGXXPj3EVMxbgmPG7sE=","cpf":"U2FsdGVkX1/Ac0+o03gMdWXobSM9a421yjTb/T9N+SM="},
{"num_cand":"U2FsdGVkX18r6zMylybQ0/ie0d39dFTkYHzaDpZEbrc=","cpf":"U2FsdGVkX19lRiyDzt0yi63Dn2QbufNMtahWMPkcss0="},
{"num_cand":"U2FsdGVkX18d+P3i0chJOpUXeKCnsK42vrWoqh9Fw3w=","cpf":"U2FsdGVkX19tgP82Tv+TumElm40wn7WZbgd6YPUFts4="},
{"num_cand":"U2FsdGVkX1/NodpWvdnMkAFno3nepx2nmXRYx6MTVW0=","cpf":"U2FsdGVkX19jZbkVA/Pb4wNr/E56Y7u5BTro6Y2gchY="},
{"num_cand":"U2FsdGVkX19V9R/mHtsZ4CHSqhp50+H/gmtuxmNsIyw=","cpf":"U2FsdGVkX19fvDNKV6CLRp/MRpJuA+S8MAtL93uMb6s="},
{"num_cand":"U2FsdGVkX18LMUMjp8K56sNtt8wON2S0RLA8Qgs8PSM=","cpf":"U2FsdGVkX1/Nf3uglB0zk7KT7QfvcO3z7bgOw8kr0Dc="},
{"num_cand":"U2FsdGVkX1+AQFvO+uZqOd+2JXn8t+ZJ/vpox6GZNSQ=","cpf":"U2FsdGVkX19BPK+UplpKgLz20mChzuBI35P+5Yf6z7c="},
{"num_cand":"U2FsdGVkX19dxUxTFURFVvNd1zW3sANQybWltsZTQh4=","cpf":"U2FsdGVkX19U8wFgciMhmvHyTxPXDpgG8OCOGXoJCSY="},
{"num_cand":"U2FsdGVkX18e+XBzz6VK+nA8klV7hR8saQ8S+b9fmZM=","cpf":"U2FsdGVkX1+oqy0r4wHvHHLRXSAQVz9xXetcnVT+9jQ="},
{"num_cand":"U2FsdGVkX1/FNIGop5FUZmcaERPOiT/85iXRY16oe+4=","cpf":"U2FsdGVkX18G7lfy+RpI1FyHOihZa3dXXhQkxq2fhWE="},
{"num_cand":"U2FsdGVkX1809LsL4xVhuMbTvmPovtUnJKfFA1oQZ6U=","cpf":"U2FsdGVkX19gw5OzVz6baR5CbdLbzb48SS9eVTuXkxw="},
{"num_cand":"U2FsdGVkX19ItGNnvAPyKpxJZWsz7/h5ShdEkS1lTJc=","cpf":"U2FsdGVkX1/1nQQnMuKNI8M1vDpCS+aFF8ttjW35JIA="},
{"num_cand":"U2FsdGVkX190uLc91SbXNb1R1zjmVKVYZqSqyFMG4G4=","cpf":"U2FsdGVkX1+67RQ60RifopGtcQIKBjp9p8kwHQCCtzw="},
{"num_cand":"U2FsdGVkX19iXtm4P/Ab/Sl1ShMtHbT9unKlRzghR0o=","cpf":"U2FsdGVkX188IYBPq5rziNntrfbiPvFV+0q4C/+JPVg="},
{"num_cand":"U2FsdGVkX1/IbvwYV8XJ08VLXhfaMp8g+j5pHxugyuI=","cpf":"U2FsdGVkX19qA6rNwPpOfmng3EIgZ3Rdh1w9a1MylLw="},
{"num_cand":"U2FsdGVkX18eZzPYp0pZEffb/J1EosL5GbC9UOtNbbM=","cpf":"U2FsdGVkX1/l9WCa7xppOpq3Al36wBSpWWdTReT6YE4="},
{"num_cand":"U2FsdGVkX183wpTrjkTedAG1a4F+g+qaNVL3gZ6+9SM=","cpf":"U2FsdGVkX1/evI2xgSSraJM5cwknRR2ZN0Hsmm2WG8s="},
{"num_cand":"U2FsdGVkX1/xsWqSI3nj144nNpF6j+FNb7yZUEo+Brw=","cpf":"U2FsdGVkX1+HeTawCS/tzHX+T80xxAEFCyDifwtibYo="},
{"num_cand":"U2FsdGVkX19Mg74kI1aNZpUerds/jTp9dZiuYA9rVT0=","cpf":"U2FsdGVkX1+SSPWT68KmuPQiqG9GcNgGfnwpWWIlFnc="},
{"num_cand":"U2FsdGVkX187OqHGWxJblnFubJgL4L2Gjpde4YuLs/I=","cpf":"U2FsdGVkX1/yzMMZ55McLs0qD1eFetXyYchHJwzqZGk="},
{"num_cand":"U2FsdGVkX1/DMGyYCR8dFfLaCrr8XD1+XlBrAyZSghA=","cpf":"U2FsdGVkX1/lwO0MkZs1ZdWDaggnzFh5Gps2jKgNbK8="},
{"num_cand":"U2FsdGVkX1/9+BLgjNe7I+KSTGuNq69v2l5krTBzxAg=","cpf":"U2FsdGVkX19qD/3UOBichxymDCTCgQcCGvetBvUtkNo="},
{"num_cand":"U2FsdGVkX1+1zxTw3D3w2l8unyoZIxM5B1yMGdI+OyY=","cpf":"U2FsdGVkX1/izKVywU3jdATZfbDG8qqYUFbeBeo2B0g="},
{"num_cand":"U2FsdGVkX19w8ZATXPJXLilHccdn0mnr6/kKo4wKyJ4=","cpf":"U2FsdGVkX1+JJDzVjpY6K/WFd+XfwaNImNaQsXmlhLs="},
{"num_cand":"U2FsdGVkX19Z9lWXA3VY8Y+jinRyZWUeHyyzLjHXKbE=","cpf":"U2FsdGVkX1+HBmQZAPnZ+dcJmzMnxDCnIFk+/8QCZUM="},
{"num_cand":"U2FsdGVkX1+tztySptgaCMQrlX15avs/66o9k/g0k1Q=","cpf":"U2FsdGVkX1+eoF8JVJHaqtaILRbtizEkDZcnhPsC+Bw="},
{"num_cand":"U2FsdGVkX1+WZgG0mVyqUWTTxrT3MG31iU8h/Vhy26I=","cpf":"U2FsdGVkX1+T+B1y3WVfWL2cHd5GZaFCy7AaEVrTPAo="},
{"num_cand":"U2FsdGVkX19TUCQivX2z08TrO16c0llRTMPzKFDQaLg=","cpf":"U2FsdGVkX1+yRfH/Tvf4JvYCFuVIe7gbLd6AI31LnGw="},
{"num_cand":"U2FsdGVkX19cxWQm/1HMY20EL5dtbN+Er1NjXhqGLGI=","cpf":"U2FsdGVkX19PQB4EPIhx4xa55Hr+/nP8PZT1xEJAEDI="},
{"num_cand":"U2FsdGVkX189pUThFkJwIHuYVHzIcbNf1ArhBPWyngs=","cpf":"U2FsdGVkX18aH+GnO/cB8EUtjTHuH6gchteJExrvUac="},
{"num_cand":"U2FsdGVkX19aMLsdzUQHEN07IQ6zFW/RbWjUfhEDko0=","cpf":"U2FsdGVkX1/QBuq592foNqZ/EwyWvrWwmfzq+3yPxDk="},
{"num_cand":"U2FsdGVkX1+bONmF35wrGJROIVExrNP1Terii4e2tcw=","cpf":"U2FsdGVkX1/1IDpJ6jnLO6WpmhtiR4bH4hnvl4YIceM="},
{"num_cand":"U2FsdGVkX1++cCYCMetCCLcZBwTiHevrUXvUh4EYe+E=","cpf":"U2FsdGVkX18yeD62I1rAJuiFuG8FrHM+21Mvz34FST8="},
{"num_cand":"U2FsdGVkX1/Cj+dP43U/tSO8W9XodvSE+qoLEfDxC4k=","cpf":"U2FsdGVkX18jx9qOALBi0o7qiMA5dMmqVhs6B5OdZsM="},
{"num_cand":"U2FsdGVkX1+z9p25b32LJKyl+5OGs25IVT+31Oxhra4=","cpf":"U2FsdGVkX1/fu95dsdxyC86EX02UsRzuOXg62J68j2Q="},
{"num_cand":"U2FsdGVkX1/Awg9Aqr9viwk8+5lBiq69Alpa25xyKfk=","cpf":"U2FsdGVkX1/a7AX9m/e8hQlzXLyi6tT6rbhQbYszMeY="},
{"num_cand":"U2FsdGVkX1+2p47RNug9W00RNqnZtrtPwUv+3ayHodI=","cpf":"U2FsdGVkX19O5G13/IWpfYBQQ1OKsLTC0dghf0CCRY8="},
{"num_cand":"U2FsdGVkX19jw5G6h/CXS6I1frkjpfMbsgaKRt0BXb8=","cpf":"U2FsdGVkX1/lOv5yf9+Ui8dkKwT9eByCPR35lZY5a34="},
{"num_cand":"U2FsdGVkX18WUMQ+MDk+1XQJC/EredqcKG26EKy+F1M=","cpf":"U2FsdGVkX18q6hLpoPajWHOG+aaCWj6lLVFoBtRFR08="},
{"num_cand":"U2FsdGVkX1/9H7MUyAWN8hjHVWFtBx4Hix8EwJr2PcU=","cpf":"U2FsdGVkX19mkJ4nnVANk9omZAmsNMqLTGgtyZ8jjhI="},
{"num_cand":"U2FsdGVkX1+sQ7MK3CBdrTeFc/6AWPxxuPijvNziOmQ=","cpf":"U2FsdGVkX1/ehY896ByRnMeAC+5szvSVrwaQFKIe1YU="},
{"num_cand":"U2FsdGVkX18SF586GaYkbEew6nDFrIhkkhrw1xT7yms=","cpf":"U2FsdGVkX1/qytJeYLwX9G63f259h7zTmUkCdy7XCW4="},
{"num_cand":"U2FsdGVkX19fccP433WLaSjGhUMf0z+CVLxfx//5Twc=","cpf":"U2FsdGVkX18FlKIaXVwIcAxzCHWIXTy8uT5+at4CrcU="},
{"num_cand":"U2FsdGVkX18JhSG9RRKL2VU56HjKX5yxN0lymFrA7mM=","cpf":"U2FsdGVkX1/Rdv4KlY6kTgb1E1XRyyYywtM8ab79VIc="},
{"num_cand":"U2FsdGVkX1/wJvc9Cxd7Nb9mIMYgOlDzO5n5cH38uNA=","cpf":"U2FsdGVkX1/ZZCdTGtm7XAN0/MHwxmfraTxS3HBuabk="},
{"num_cand":"U2FsdGVkX1/Fwuc1m7KzQW3pQE6r8h6AHykxNv4/nDA=","cpf":"U2FsdGVkX18RAX0PS4iRTetegDPPAZkpEKcDwQ4zDI4="},
{"num_cand":"U2FsdGVkX1/9LHkcmJhbqlq8ev0hnu7NNB3oX3mqNCI=","cpf":"U2FsdGVkX18Go47IhS142G3yBhvEzU2BRC1sQzBvcYQ="},
{"num_cand":"U2FsdGVkX1+NWcHH4S+tMQ0h45/heVXpHCXKB4hS7rE=","cpf":"U2FsdGVkX1+4ckMVVxIgCyW297DxT4Ss85D/EfrHRDM="},
{"num_cand":"U2FsdGVkX18EheX1rxYd1e3PcbqqDmf3ELyDWu4KcRc=","cpf":"U2FsdGVkX19VAI7TOpZk7xfA6f0BwwFZOw+TOq0jSBs="},
{"num_cand":"U2FsdGVkX19dMpelb6zjtT0T8JZrnDIUn2CcMAagDS0=","cpf":"U2FsdGVkX19YkvHZ3NCWE8hQUwPT5AvGU8p6s5loW48="},
{"num_cand":"U2FsdGVkX19l5aS/48viOgyZvhK46r6EzupXWLzNjeY=","cpf":"U2FsdGVkX19Fx2VPeokv9oFeh0lTZng0dvypxkRNKJQ="},
{"num_cand":"U2FsdGVkX1/nwM6JWNmmh+rRQX2DOP0tUe/lg893pU0=","cpf":"U2FsdGVkX18GjOOqMde4A+T2VuHLXHtDUa88jjcFKIE="},
{"num_cand":"U2FsdGVkX19PqnxmgZoueM9RYdrhtQyJQ5jIGlvs4FQ=","cpf":"U2FsdGVkX18lVNlM6SQXBILW+ZDzB9Gv0lDKziWBpEc="},
{"num_cand":"U2FsdGVkX1+VMf9TCgDB82AIJ24grruwWCwr0wqd0F4=","cpf":"U2FsdGVkX1+yB1cs5qkC8rQZKkEsXWN8keyzpOUyUZ4="},
{"num_cand":"U2FsdGVkX1+NJFyfu1AX357F6tINSALieuqoWdJ6Dyc=","cpf":"U2FsdGVkX1/rFOvh+n9VafQ5bvZwHxiNOd83oSnhgEI="},
{"num_cand":"U2FsdGVkX1/juGV6/GUvSJQ1q3BEDqaLsXxmdM2h+4Q=","cpf":"U2FsdGVkX19Se9UEjLypPqczPY9jRLrXWvnmlZ1hvmc="},
{"num_cand":"U2FsdGVkX18XASYPMerNU8AyMXPqg7oMOGQ9w7MpYWM=","cpf":"U2FsdGVkX1/iOP/HUlZsChlMxmLiMiwtK113hK+XeBw="},
{"num_cand":"U2FsdGVkX1826r4N/cPfao2BHEWB2+b22GgmATtpyGA=","cpf":"U2FsdGVkX1+lYX5iri5lfUzCzvLXSaDRugBSpfjNYsg="},
{"num_cand":"U2FsdGVkX1+yg4HwVZbZI/Ba+gAdLtHDPmlnEbhCI4Y=","cpf":"U2FsdGVkX18qnamtut/yMyuBOKaTemEVg209ipGiimo="},
{"num_cand":"U2FsdGVkX18+I/6wD8TrbQLbNHk5/1WYv72/6IwQ/tQ=","cpf":"U2FsdGVkX18UvDu6egd79evokeImBX1GWMS6fSbEEZw="},
{"num_cand":"U2FsdGVkX1/E0WJDDP4yX7lynZYKuYgsoDJupJPz8HE=","cpf":"U2FsdGVkX1+tiu9k3xImFeI9MotqMWvIou+hqpAy59Y="},
{"num_cand":"U2FsdGVkX19tBcUfbDPFV2D90nWlYzIHF12c1FgTu10=","cpf":"U2FsdGVkX19ucPIj43hhOfQ2MJf8L/1c7E22YcnLliU="},
{"num_cand":"U2FsdGVkX1+O1qsj1vGMT7t9L22y2kU3y5JgnxX8Iz4=","cpf":"U2FsdGVkX1/NtwCIuRl0HbcAVmvv889nNuBsOvjE8Jw="},]


      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
            let num_cand_decripted = decrypt(login.num_cand);
            let cpf_decripted = decrypt(login.cpf);

            // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
             let nome_arquivo = (gera_file_name(cpf_decripted,num_cand_decripted))


            // alert(`Logou`);
              let url = (`https://fs.ibfc.org.br/arquivos/2106/2106_rec_cl/${nome_arquivo}`)
            return window.location.replace(url);
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
